var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"c"},React.createElement("path",{"id":"Path_7","data-name":"Path 7","d":"M0,4.027H1.521V3.278A4.809,4.809,0,0,1,1.8,1.4,2.162,2.162,0,0,1,2.823.39,4.055,4.055,0,0,1,4.709,0,7.957,7.957,0,0,1,7,.339l-.37,1.84a5.626,5.626,0,0,0-1.258-.151,1.142,1.142,0,0,0-.853.268A1.5,1.5,0,0,0,4.26,3.324v.7H6.308V6.1H4.26V14H1.521V6.1H0V4.028Z","fill":"#33342e"})));
}

Facebook.defaultProps = {"id":"Menu_FB","data-name":"Menu FB","width":"7","height":"14","viewBox":"0 0 7 14"};

module.exports = Facebook;

Facebook.default = Facebook;
